module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-info"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-grid"
  }, [_c('div', {
    staticClass: "p-col"
  }, [_c('Button', {
    staticClass: "p-button-raised p-mr-2",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "pi pi-plus"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openBasic.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '40vw'
    }),
    attrs: {
      "header": "Item Category",
      "visible": _vm.displayBasic,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.displayBasic = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "p-fluid p-formgrid p-grid"
        }, [_c('div', {
          staticClass: "p-field p-col-12 p-md-6"
        }, [_c('Button', {
          staticClass: "p-button-raised",
          attrs: {
            "label": !_vm.editing ? 'Add' : 'Update'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addCategory.apply(null, arguments)
            }
          }
        }), _vm._v(" "), (!_vm.editing) ? _c('Button', {
          staticClass: "p-button-raised p-button-info",
          attrs: {
            "label": "Add & New"
          }
        }) : _vm._e(), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancel.apply(null, arguments)
            }
          }
        })], 1)])]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Category Name"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "name"
    },
    model: {
      value: (_vm.categoryName),
      callback: function($$v) {
        _vm.categoryName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "categoryName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('span', [_vm._v("Depreciation")])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "audit"
    }
  }, [_vm._v("Audit")]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('Checkbox', {
    attrs: {
      "id": "audit",
      "binary": true
    },
    model: {
      value: (_vm.audit),
      callback: function($$v) {
        _vm.audit = $$v
      },
      expression: "audit"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "poolType"
    }
  }, [_vm._v("Pool Type")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.poolTypeList,
      "optionLabel": "name",
      "placeholder": "Select Pool Type",
      "id": "poolType"
    },
    model: {
      value: (_vm.poolType),
      callback: function($$v) {
        _vm.poolType = $$v
      },
      expression: "poolType"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "depreciation"
    }
  }, [_vm._v("Depreciation")]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('span', [_vm._v(_vm._s(_vm.poolType.percentage))])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "company"
    }
  }, [_vm._v("Company")]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('Checkbox', {
    attrs: {
      "id": "company",
      "binary": true
    },
    model: {
      value: (_vm.company),
      callback: function($$v) {
        _vm.company = $$v
      },
      expression: "company"
    }
  })], 1)])]), _vm._v(" "), (_vm.company === true) ? _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "depreciation"
    }
  }, [_vm._v("Depreciation")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "depreciation"
    },
    model: {
      value: (_vm.companyDepreciationPercentage),
      callback: function($$v) {
        _vm.companyDepreciationPercentage = $$v
      },
      expression: "companyDepreciationPercentage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "lifeSpan"
    }
  }, [_vm._v("Life Span")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "lifeSpan"
    },
    model: {
      value: (_vm.lifeSpan),
      callback: function($$v) {
        _vm.lifeSpan = $$v
      },
      expression: "lifeSpan"
    }
  })], 1)]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-088a1232"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/fixedAssets/categorySetup.vue
// module id = 2023
// module chunks = 0